import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Viewerlayer } from "../../../model/viewerlayer";
import { toolbarOptions } from "../../../../shared/model/toolbar-constants";
import { LayerCommunicatorService } from "../../../services/communicators/layer-communicator.service";
import { ToolbarService } from "../../../services/internal-services/toolbar.service";
import { ViewerConstants } from "../../../../shared/model/viewer-constants";
import { OverlayDialogComponent } from "../../../../dialog-components/overlay-dialog/overlay-dialog.component";
import { BaseLayerManagerComponent } from "../base-layer-manager/base-layer-manager.component";
import { FeaturesSearchService } from "../../../services/internal-services/features-search.service";
import { LayerService } from "../../../services/internal-services/layer.service";
import { MapService } from "../../../services/internal-services/map.service";
import { FeatureFlagsService } from "../../../services/internal-services/feature-flags.service";
import { GoogleAnalyticsService } from "../../../../shared/services/google-analytics.service";
import { AddUserDataDialogComponent } from "../../../../dialog-components/add-user-data-dialog/add-user-data-dialog.component";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-collection-manager",
  templateUrl: "./collection-manager.component.html",
  styleUrls: ["./collection-manager.component.scss"],
  standalone: false,
})
export class CollectionManagerComponent extends BaseLayerManagerComponent implements OnDestroy, AfterViewInit {
  collectionLayers: Viewerlayer[] = [];

  toolbarOption = toolbarOptions.COLLECTION_MANAGER;

  selectedLayer: Viewerlayer;

  constructor(
    public googleAnalyticsService: GoogleAnalyticsService,
    public mapService: MapService,
    public layerCommunicatorService: LayerCommunicatorService,
    public matDialog: MatDialog,
    public toolbarService: ToolbarService,
    public featuresServiceSearch: FeaturesSearchService,
    public layerService: LayerService,
    public flagService: FeatureFlagsService,
  ) {
    super(
      googleAnalyticsService,
      mapService,
      layerCommunicatorService,
      matDialog,
      toolbarService,
      featuresServiceSearch,
      layerService,
      flagService,
    );
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.subscriptions.push(
      this.viewerService.collectionLayers$.subscribe((layers: Viewerlayer[]) => {
        this.collectionLayers = layers;
      }),
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  changeVisibility(event: any) {
    const layer = event.layer as Viewerlayer;
    if (ViewerConstants.SOURCE_NAME.COLLECTION === layer.sourceName) {
      this.viewerService.changeCollectionVisibility(layer.id, event.value);
    } else if (layer.aoi) {
      this.viewerService.changeAOIVisibility(layer.id, event.value);
    } else {
      this.viewerService.changeLayerVisibility(layer.id, event.value);
    }
  }

  changeCollectionOrder(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.collectionLayers, event.previousIndex, event.currentIndex);
    this.updateCollectionOrder();
  }

  updateCollectionOrder() {
    this.viewerService.updateCollectionOrder(this.collectionLayers);
  }

  changeWMSChildVisibility(event: MatCheckboxChange, childLayer: string) {
    this.mapService.getCoreMap().changeVisibilityWMSChild(event.checked, childLayer, event.source.value);
  }

  showUploadDialog() {
    const dialog = this.matDialog.open(AddUserDataDialogComponent, {
      data: {
        title: "Add WMS or WMTS layer from URL",
        viewerService: this.viewerService,
      },
      panelClass: "medium-panel-dialog",
    });
    dialog.afterClosed().subscribe(() => {});
  }

  removeUserLayer(layerId: string) {
    const dialog = this.matDialog.open(OverlayDialogComponent, {
      data: {
        text: "Are you sure you want to remove this layer?",
        isConfirmation: true,
      },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.viewerService.removeUserLayer(layerId);
      }
    });
  }

  zoomToFeature(layer: Viewerlayer, feature: any) {
    super.zoomToFeature(layer, feature);
  }

  showLayerInfo(layer: Viewerlayer) {
    this.selectedLayer = layer;
  }
}
